module.exports = __webpack_public_path__ + "img/code-css-sm.0e398c71.webp";